import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { listItemLead } from './list-styles'

/**
 * The leading node of a list row that carries something other than a 14px icon, such as a workspace
 * tile or a person's initials. Must be the row's first child; rows without a lead indent to match.
 */
function ListItemLead({ className, children, ...props }: ComponentProps<'span'>) {
  return (
    <span data-slot="list-item-lead" className={twMerge(listItemLead, className)} {...props}>
      {children}
    </span>
  )
}

export { ListItemLead }
